var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',[_c('span',[_vm._t("default")],2),_vm._v(" "),(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }